<!--
 * @Author: 孙照
 * @LastEditTime: 2024-01-02 15:14:30
 * @Description: 模块标题组件
 * @FilePath: \sheyang\src\components\infoTitle\index.vue
-->
<template>
  <div
    class="pub-info-title"
    :class="{
      'modal-info-title-bg': isModal,
      'modal-info-title-long-bg': isModalLong
    }
    ">
    <img class="arrow-img" src="@/assets/images/apng/infoTitleArrow.png" alt="">
    <p class="title-font">{{ title }}</p>
    <img class="rect-img" src="@/assets/images/apng/infoTitleRect.png" alt="">
  </div>
</template>

<script>
export default {
  name: 'pubInfoTitle',
  props: {
    title: {
      default: '',
      type: String,
    },
    isModal: {
      default: false,
      type: Boolean,
    },
    isModalLong: {
      default: false,
      type: Boolean,
    },
  },
};
</script>

<style lang="less" scoped>
.pub-info-title {
  width: 437px;
  height: 40px;
  overflow: hidden;
  position: relative;
  .backgroundImage('@/assets/images/infoTitleBg.png');
  .displayFlex(flex-start, center);
  &.modal-info-title-bg {
    width: 471px;
    overflow: hidden;
    position: relative;
    .backgroundImage('@/assets/images/modalInfoTitleBg.png');
    .displayFlex(flex-start, center);
  }
  &.modal-info-title-long-bg {
    width: 765px;
    overflow: hidden;
    position: relative;
    .backgroundImage('@/assets/images/infoTitleLongBg.png');
    .displayFlex(flex-start, center);
  }
  .arrow-img {
    width: 48px;
    height: 48px;
    margin-left: -5px;
  }
  .title-font {
    margin-left: 10px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    text-shadow: 0px 0px 8px #00B2FF;
  }
  .rect-img {
    width: 93px;
    height: 35px;
    position: absolute;
    right: 0;
  }
}

</style>
